import cookies from 'js-cookie'

var cookie = {
  get: (k) => cookies.get(k),
  set: (k, v) => cookies.set(k, v),
  rm: (k) => cookies.remove(k),
  getJSON: function (k) {
    var x = cookies.get(k)
    if (x !== undefined) {
      return JSON.parse(x)
    } else {
      return undefined
    }
  },
  setJSON: (k, v) => cookies.set(k, JSON.stringify(v)),
}

export { cookie as default }
